import { render } from "./Image.vue?vue&type=template&id=65d69888&scoped=true"
import script from "./Image.vue?vue&type=script&lang=ts"
export * from "./Image.vue?vue&type=script&lang=ts"

import "./Image.vue?vue&type=style&index=0&id=65d69888&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65d69888"

export default script